import { postData } from './api'

export default class OrderListLongPolling {
	constructor(setOrderListUpdater) {
		this._setOrderListUpdater = setOrderListUpdater
		this._isPollingStarted = false
	}

	public updateOrderList(currentDate: number): void {
		this._startPolling(currentDate)
	}

	public async awaitApprovedLikeStatus(dealerId, orderNumber) {
		const result = await postData('/api/v1/OnOrderUpdate', { dealerId, orderNumber, type: 'onApprovedLikeStatus' })
		return result
	}

	private async _startPolling(currentDate): void {
		if (!this._isPollingStarted) {
			this._isPollingStarted = true
			let onFailTO = setTimeout(() => {
				this._isPollingStarted = false
			}, 1000 * 20)
			const result = await postData('/api/v1/updateOrderList', { currentDate })
			if (result.update) {
				if (typeof this._setOrderListUpdater === 'function') {
					this._setOrderListUpdater(Date.now())
					this._isPollingStarted = false
					clearTimeout(onFailTO)
				}
			}
		}
	}
}